export function DashSymbol() {
  return <span>&mdash;</span>;
}

export function DotSymbol() {
  return <span>&bull;</span>; // >&#8226;
}

// Recycled

// 30 Apr 2025

// export default function Symbol({ name }: { name: keyof typeof symbols }) {
//   return <span>{symbols[name]}</span>;
// }

// 15 Feb 2026

// const symbols = {
//   dash: "\u2014", // — (em dash)
//   dot: "\u2022", // • (bullet)
// };
